module.exports = __webpack_public_path__ + "img/add-way-2.33ff1a15.png";